import Color from "color";
import { derived } from "svelte/store";

import { paletteConfig } from "../store/palette";
import { remoteConfig } from "../store/remoteConfig";
import { gxThemeConfig } from "../store/theme";
import { hslColors, hslNewColors } from "./utils";

export const themeConfig = derived(
  [remoteConfig, paletteConfig, gxThemeConfig],
  ([$remoteConfig, $palette, $theme]) => {
    if (!$remoteConfig) {
      return;
    }

    const {
      colors = $remoteConfig.colors ? $remoteConfig.colors : null,
      contentInsets: { left, right },
    } = $remoteConfig;

    const URLparams = new URLSearchParams(window.location.search);
    const browserVars = URLparams.get("colors");

    if (window?.opr?.palette) {
      const gx_accent = $palette.gx_accent;
      const primaryText = $theme === "dark" ? "0 0% 100%" : "0 0% 0%";
      const accentColor = Color.hsl({
        h: gx_accent?.h,
        s: gx_accent?.s * 100,
        l: gx_accent?.l * 100,
      });
      const fontColor = accentColor.luminosity() > 0.45 ? "0 100% 0%" : "0 100% 100%";

      return {
        palette: {
          ...hslNewColors($palette, $theme),
          "color-font-accent": `${fontColor}`,
          "color-primary-text": `${primaryText}`,
          "inset-left": `${left || 18}px`,
          "inset-right": `${right || 18}px`,
        },
        theme: $theme,
      };
    }

    if (browserVars) {
      return {
        ...hslColors(JSON.parse(browserVars)),
        "inset-left": `${left || 18}px`,
        "inset-right": `${right || 18}px`,
      };
    }

    return {
      ...hslColors(colors),
      // NOTE(duanei): There seems to be a bug on iOS that cause the value to be zero sometimes.
      // We'll mitigate that by defaulting to 18 the typical iOS value.
      "inset-left": `${left || 18}px`,
      "inset-right": `${right || 18}px`,
    };
  },
);
